import type { InventoryVehicle } from '@carvana/merch-contracts';
import {
  defaultLoadableState,
  LoadableState,
  useLoadableState
} from '@carvana/merch-react-hooks';
import React, { createContext, useMemo, useState, useCallback } from 'react';

type SuggestedForYouContextType = {
  fetchSuggestedForYouTrigger: number;
  suggestedVehicles: LoadableState<InventoryVehicle[]>;
  triggerFetchSuggestedForYou: () => void;
};

export const defaultContext: SuggestedForYouContextType = {
  fetchSuggestedForYouTrigger: 0,
  suggestedVehicles: defaultLoadableState<InventoryVehicle[]>([]),
  triggerFetchSuggestedForYou() {}
};

const SuggestedForYouContext =
  createContext<SuggestedForYouContextType>(defaultContext);

export function SuggestedForYouContextProvider({
  children
}: React.PropsWithChildren) {
  const suggestedVehicles = useLoadableState<InventoryVehicle[]>([]);

  const [fetchSuggestedForYouTrigger, setTrigger] = useState(
    defaultContext.fetchSuggestedForYouTrigger
  );

  const triggerFetchSuggestedForYou = useCallback(() => {
    setTrigger(Date.now());
  }, []);

  const value = useMemo<SuggestedForYouContextType>(
    () => ({
      fetchSuggestedForYouTrigger,
      suggestedVehicles,
      triggerFetchSuggestedForYou
    }),
    [
      fetchSuggestedForYouTrigger,
      suggestedVehicles,
      triggerFetchSuggestedForYou
    ]
  );

  return (
    <SuggestedForYouContext.Provider value={value}>
      {children}
    </SuggestedForYouContext.Provider>
  );
}

SuggestedForYouContextProvider.displayName = 'SuggestedForYouContextProvider';

export default SuggestedForYouContext;
